import { createContext, useContext } from "react";

export const ContainerState = createContext({});

function useContainerState() {
    const {
        containerState,
        setContainerState,
        loaderHandler,
        categoryProductType,
        setCategoryProductType,
        JSONFeedAttributesData,
        setJSONFeedAttributesData,
        renderJSONFeed,
        setRenderJSONFeed,
        allProductTypes
    } = useContext<any>(ContainerState);
    if (containerState === undefined) {
        throw new Error("Context error!");
    }
    return {
        containerState,
        setContainerState,
        loaderHandler,
        categoryProductType,
        setCategoryProductType,
        JSONFeedAttributesData,
        setJSONFeedAttributesData,
        renderJSONFeed,
        setRenderJSONFeed,
        allProductTypes
    };
}

export default useContainerState;